import { useTheme } from '@emotion/react';
import { Divider, Grid, InputLabel, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import useAryLayoutType from 'framework/base/hooks/useAryLayoutType';
import React from 'react';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';
import { imageAddressPrefix } from 'spec';
import { CustomTypographyTertiary } from './StyledComponents';

const EmptyDropZone = ({ isHover, hasWebcam }) => {
  const layoutType = useAryLayoutType();
  const theme = useTheme();
  const { t } = useFrameworkTranslation();
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing="1rem"
      width="100%"
    >
      <Grid
        item
        xs={12}
        display="flex"
        flexDirection={layoutType !== 'mobile' && 'column'}
        alignItems="center"
        gap={5}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="100%"
          padding=".5rem"
          backgroundColor="#CFEEFB"
          border={`.5rem solid ${theme.chip.blue.background}`}
        >
          <img
            alt="cloud"
            src={`${imageAddressPrefix}static/img/illustrations/Cloud.svg`}
            style={{
              width: layoutType === 'mobile' ? '35px' : '2.25rem',
              height: layoutType === 'mobile' ? '35px' : '2.25rem'
            }}
          />
        </Box>
        <Grid container direction="column" gap={2} alignItems="center">
          <InputLabel
            sx={{
              cursor: isHover && 'pointer'
            }}
          >
            {layoutType === 'mobile' || layoutType === 'tablet' ? (
              t('uploadFileWithTouch')
            ) : (
              <Typography variant="c3Bold">
                {`${t('Drop Your Desired File Here')} ${t('Or')}`}
                <Typography variant="c3Bold" color={theme.palette.primary.main}>
                  {' '}
                  {t('Choose')}
                </Typography>
                {hasWebcam && (
                  <>
                    <Divider
                      sx={{
                        '&::before': {
                          borderTopStyle: 'dashed'
                        },
                        '&::after': {
                          borderTopStyle: 'dashed'
                        }
                      }}
                    >
                      <CustomTypographyTertiary>
                        {t('Or')}
                      </CustomTypographyTertiary>
                    </Divider>
                    <Typography
                      variant="c3Bold"
                      color={theme.palette.primary.main}
                    >
                      {t('UseWebcam')}
                    </Typography>
                  </>
                )}
              </Typography>
            )}
          </InputLabel>
          <InputLabel
            sx={{
              cursor: isHover && 'pointer'
            }}
          >
            <CustomTypographyTertiary>
              {t('uploaderInputLabelMaximumSize')} {t('And')}
              <br />
              {t('FileUploaderInputLabelFormat')}
            </CustomTypographyTertiary>
          </InputLabel>
        </Grid>
      </Grid>
    </Stack>
  );
};
export default EmptyDropZone;
